import './Footer.scss';
import EmailIcon from '../EmailIcon';

const InstagramIcon = () => (
    <img src='/icons/instagram.ico' alt='Instagram' width={18} height={18} style={{ borderRadius: '3px' }} />
);

const ArmenianArtistsIcon = () => (
    <img src='/icons/Armenian-artist-project.svg' alt='Anna Hovan - Armenian Artists Project' width={18} height={18} style={{ borderRadius: '3px' }} />
);

const SaatchiIcon = () => (
    <img src='/icons/Saatchi.ico' alt='Saatchi Art' width={18} height={18} style={{ borderRadius: '3px' }} />
);

const ArtmajeurIcon = () => (
    <img src='/icons/artmajeur.webp' alt='Artmajeur' width={18} height={18} style={{ borderRadius: '3px' }} />
);


function Footer() {
  return (
    <footer className='footer'>
      <div className='footer-inner'>
        <div className='footer-brand'>
          <span className='footer-name'>Anna Hovan</span>
          <span className='footer-tagline'>Contemporary Artist</span>
        </div>

        <div className='footer-links'>
          <a href='https://www.instagram.com/annahovan' target='_blank' rel='noreferrer'>
            <InstagramIcon />
            <span>Instagram</span>
          </a>
          <span className='footer-dot' />
          <a href='https://www.armenianartistsproject.org/artist-artwork-list/04b2a740-cecd-11f0-b6cd-a58d4575f597?offset=0&limit=20' target='_blank' rel='noreferrer' className='footer-link-wrap'>
            <ArmenianArtistsIcon />
            <span>Anna Hovan — Armenian Artists Project</span>
          </a>
          <span className='footer-dot' />
          <a href='https://www.saatchiart.com/annahovan' target='_blank' rel='noreferrer'>
            <SaatchiIcon />
            <span>Saatchi Art</span>
          </a>
          <span className='footer-dot' />
          <a href='https://www.artmajeur.com/anna-hovan' target='_blank' rel='noreferrer'>
            <ArtmajeurIcon />
            <span>Artmajeur</span>
          </a>
          <span className='footer-dot' />
          <a href='mailto:annahovann@gmail.com'>
            <EmailIcon />
            <span style={{ textTransform: 'none' }}>annahovann@gmail.com</span>
          </a>
        </div>

        <div className='footer-copy'>
          © {new Date().getFullYear()} Anna Hovan. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
